import { InventoryTurnoverValues, InventoryTurnoverResult } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

// Inventory Turnover = Cost of Goods Sold / Average Inventory
export function calculateInventoryTurnover(values: InventoryTurnoverValues, t?: ToolsTranslations['inventoryTurnover']): InventoryTurnoverResult {
  const { costOfGoodsSold, beginningInventory, endingInventory } = values;

  if (costOfGoodsSold < 0) return { turnover: null, isValid: false, message: t?.invalid.costOfGoodsSold };
  if (beginningInventory < 0) return { turnover: null, isValid: false, message: t?.invalid.beginningInventory };
  if (endingInventory < 0) return { turnover: null, isValid: false, message: t?.invalid.endingInventory };

  const averageInventory = (beginningInventory + endingInventory) / 2;
  if (averageInventory <= 0) return { turnover: null, isValid: false, message: t?.invalid.generic };

  const turnover = Math.round((costOfGoodsSold / averageInventory) * 100) / 100; // 2 decimals as in example 9,09
  if (!isFinite(turnover)) return { turnover: null, isValid: false, message: t?.invalid.generic };

  return { turnover, isValid: true, averageInventory };
}


